import { useAuth } from '../context/AuthContext'
import { ACCOUNT_URL, UPGRADE_URL } from '../lib/access'

// Legacy subscribers (who bought before the Geezword account) manage billing
// through the existing Stripe portal link; everyone else uses the account page.
const STRIPE_PORTAL_LINK = import.meta.env.VITE_STRIPE_PORTAL_LINK

export function useSubscription() {
  const { user, isPremium, subscription, hasAccountSubscription } = useAuth()

  // New subscriptions are sold only on the Geezword account page.
  const startCheckout = () => {
    window.location.href = UPGRADE_URL
  }

  const manageSubscription = () => {
    const legacy = !hasAccountSubscription && STRIPE_PORTAL_LINK
    window.open(legacy ? STRIPE_PORTAL_LINK : `${ACCOUNT_URL}/`, '_blank')
  }

  return {
    isPremium,
    subscription,
    startCheckout,
    manageSubscription,
    isLoggedIn: !!user
  }
}
